import { DashboardPage } from '@/domains/dashboard';
import { resolveLandingPath } from '@/shared/config/navigation';
import { useAccessControl } from '@skewb/access-control/react';
import { Loader2 } from 'lucide-react';
import { Navigate } from 'react-router';

/**
 * Index-route landing (WRK-5474). The Dashboard is guarded by `read Report`, so a role
 * without it (Scheduler, Planner, Engineering, Support) used to hit a 403 the moment it
 * logged in — every path redirects to `/`. Instead, resolve the first screen the user
 * can actually access: if that is the Dashboard (`/`), render it in place; otherwise
 * redirect there. Waits for the ability to hydrate so a hard refresh doesn't bounce
 * through a transient deny-all state.
 */
export function LandingRoute() {
  const { ability, isLoading } = useAccessControl();

  if (isLoading) {
    return (
      <div role="status" className="flex items-center justify-center h-full">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
        <span className="sr-only">Loading…</span>
      </div>
    );
  }

  const landingPath = resolveLandingPath(ability);
  if (landingPath === '/') {
    return <DashboardPage />;
  }

  return <Navigate to={landingPath} replace />;
}
